import React from 'react';
import CodeBlock from '../components/CodeBlock';
import './HomePage.css';

function HomePage({ onNavigate }) {
  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>React Native Lite UI</h1>
          <p className="tagline">Lightweight, customizable UI components for React Native & Web</p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => onNavigate('getting-started')}>
              Get Started
            </button>
            <button className="btn btn-secondary" onClick={() => {}}>
              View Components
            </button>
          </div>
        </div>
      </section>

      <section className="features">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎨</div>
            <h3>Theme Support</h3>
            <p>Built-in dark mode and light mode with easy theme switching</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Lightweight</h3>
            <p>Minimal bundle size, no heavy dependencies</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧩</div>
            <h3>Customizable</h3>
            <p>All components are fully customizable with props and styles</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Cross Platform</h3>
            <p>Works on React Native and Web with same APIs</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📚</div>
            <h3>Well Documented</h3>
            <p>Comprehensive documentation with examples for all components</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🚀</div>
            <h3>Easy to Use</h3>
            <p>Simple APIs that are easy to learn and integrate</p>
          </div>
        </div>
      </section>

      <section className="quick-start">
        <h2>Quick Start</h2>
        
        <div className="quick-step">
          <h3>1. Install</h3>
          <CodeBlock
            language="bash"
            code={`npm install react-native-lite-ui`}
          />
        </div>

        <div className="quick-step">
          <h3>2. Setup Theme Provider</h3>
          <CodeBlock
            language="jsx"
            code={`import { ThemeProvider } from 'react-native-lite-ui';

const theme = {
  colors: {
    primary: '#007AFF',
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    // ... more colors
  },
  fontSizes: { /* ... */ },
  fonts: { /* ... */ },
};

export default function App() {
  return (
    <ThemeProvider initialValues={theme}>
      <YourApp />
    </ThemeProvider>
  );
}`}
          />
        </div>

        <div className="quick-step">
          <h3>3. Use Components</h3>
          <CodeBlock
            language="jsx"
            code={`import { Button, Text, TextInput } from 'react-native-lite-ui';

function MyComponent() {
  return (
    <>
      <Text mode="bold" fontSize="large">
        Hello World
      </Text>
      <Button
        title="Click Me"
        onPress={() => console.log('Clicked')}
      />
    </>
  );
}`}
          />
        </div>
      </section>

      <section className="components-preview">
        <h2>Available Components</h2>
        <div className="components-grid">
          <div className="component-preview-card">
            <h4>Text</h4>
            <p>Customizable text with theme support</p>
          </div>
          <div className="component-preview-card">
            <h4>Button</h4>
            <p>Versatile button with multiple styles</p>
          </div>
          <div className="component-preview-card">
            <h4>TextInput</h4>
            <p>Input field with error handling</p>
          </div>
          <div className="component-preview-card">
            <h4>Switch</h4>
            <p>Animated toggle component</p>
          </div>
          <div className="component-preview-card">
            <h4>Checkbox</h4>
            <p>Customizable checkbox with labels</p>
          </div>
          <div className="component-preview-card">
            <h4>Toast</h4>
            <p>Non-intrusive notifications</p>
          </div>
          <div className="component-preview-card">
            <h4>Chip</h4>
            <p>Selection component for options</p>
          </div>
          <div className="component-preview-card">
            <h4>Alert</h4>
            <p>Modal alerts for user attention</p>
          </div>
          <div className="component-preview-card">
            <h4>Dialog</h4>
            <p>Customizable dialog/modal</p>
          </div>
          <div className="component-preview-card">
            <h4>BottomSheet</h4>
            <p>Sliding bottom sheet component</p>
          </div>
          <div className="component-preview-card">
            <h4>Divider</h4>
            <p>Simple divider/separator</p>
          </div>
          <div className="component-preview-card">
            <h4>And more...</h4>
            <p>Explore all components in the sidebar</p>
          </div>
        </div>
      </section>

      <section className="cta">
        <h2>Ready to get started?</h2>
        <p>Explore the documentation and start building beautiful UIs</p>
        <button className="btn btn-primary" onClick={() => onNavigate('getting-started')}>
          Go to Documentation
        </button>
      </section>
    </div>
  );
}

export default HomePage;
